import { Specs } from '@doxyme/extensions-common';
import ExtensionCapability from '../../capability';
import type ExtensionInstance from '../../instance';

type Constraints = Specs.Storage.Constraints;
type UpdatePayload = Specs.Storage.UpdatePayload;

const { Storage } = Specs;

type Store = Record<string, UpdatePayload>;

/**
 * Storage is used to set (and retrieve stored) data from the extension to the host application, to be able to keep it between mounts.
 */
export default class StorageCapability extends ExtensionCapability<Constraints> {
  static readonly id = Storage.id;

  private store: Store = {};

  constructor() {
    super(Storage);

    this.handlers.push(
      [Storage.Actions.Set, this.onSet.bind(this)],
      [Storage.Actions.Request, this.onRequest.bind(this)],
    );
  }

  /**
   * Set new value
   * @param payload - Whole store object
   */
  private onSet(
    payload: UpdatePayload,
    instance: ExtensionInstance<Constraints>,
  ): void {
    this.store[instance.id] = payload;

    instance.notify([Storage.Events.Update, this.store[instance.id] ?? {}]);
  }

  // Re-sends a cached store to the instance
  private onRequest(
    payload: never,
    instance: ExtensionInstance<Constraints>,
  ): void {
    instance.notify([Storage.Events.Update, this.store[instance.id] ?? {}]);
  }
}
